import { render, staticRenderFns } from "./TheNewCustomer.vue?vue&type=template&id=51ae126f&scoped=true"
import script from "./TheNewCustomer.vue?vue&type=script&lang=js"
export * from "./TheNewCustomer.vue?vue&type=script&lang=js"
import style0 from "./TheNewCustomer.vue?vue&type=style&index=0&id=51ae126f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ae126f",
  null
  
)

export default component.exports